export class LoginInProgressAuthError extends Error {
  public name: string;

  constructor(message: string) {
    super(message);

    this.name = 'LoginInProgressAuthError';

    Object.setPrototypeOf(this, LoginInProgressAuthError.prototype);
  }
}
